// extracted by mini-css-extract-plugin
module.exports = {"DimensionsFeature":"wi_a bhp_b bhp_ux"};